export const formatDate = (dateString) => {
  if (!dateString) return '';
  // Append T00:00:00 to avoid UTC offset issues with YYYY-MM-DD strings
  const normalized = dateString.length === 10 ? `${dateString}T00:00:00` : dateString;
  const date = new Date(normalized);
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' });
};

export const formatTime = (timeString) => {
  if (!timeString) return '';
  return timeString;
};

export const formatCurrency = (amount, currency = 'USD') => {
  // Handle undefined, null, or NaN values
  if (amount === undefined || amount === null || isNaN(amount)) {
    return currency === 'USD' ? '$0.00' : '₹0.00';
  }
  if (currency === 'USD') {
    return `$${Number(amount).toFixed(2)}`;
  } else {
    return `₹${Number(amount).toFixed(2)}`;
  }
};

export const formatPhone = (phone) => {
  return phone || '';
};

export const getEventTypeColor = (type) => {
  const colors = {
    'Wedding': '#D4AF37',
    'Pre-wedding': '#A67B5B',
    'Mehendi': '#3F6212',
    'Haldi': '#854D0E',
    'Sangeet': '#1E40AF',
    'Reception': '#991B1B',
    'Engagement': '#787878'
  };
  return colors[type] || '#1A1A1A';
};

export const calculateDaysBetween = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end - start);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays + 1;
};